// Password-recovery latch: the bridge between the session layer (which sees
// Supabase's PASSWORD_RECOVERY auth event) and the UI (which owns the "enter a
// new password" dialog). Kept as a tiny standalone module so the delivery
// semantics are unit-testable without a Supabase client.
//
// Why a latch and not a plain callback: the recovery deep-link is processed by
// the SDK asynchronously around boot (detectSessionInUrl), so the event can in
// principle fire before the auth panel has registered its handler. A missed
// event would strand the user signed in via the recovery link but never asked
// for a new password. The latch buffers one pending fire and delivers it on
// registration.

type RecoveryHandler = () => void;

let handler: RecoveryHandler | null = null;
let pending = false;

// Register the UI's recovery prompt. If a PASSWORD_RECOVERY event already
// fired, it is delivered immediately (once).
export function setPasswordRecoveryHandler(h: RecoveryHandler | null): void {
  handler = h;
  if (h && pending) {
    pending = false;
    h();
  }
}

// Called by auth/session.ts when the PASSWORD_RECOVERY auth event arrives.
export function firePasswordRecovery(): void {
  if (handler) handler();
  else pending = true;
}

// Test hook: clear module state between cases.
export function _resetRecoveryLatchForTests(): void {
  handler = null;
  pending = false;
}
